import moment from 'moment';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { DEPTH } from 'src/common/constants';
import { currencyFormatter } from 'src/common/helpers';
import { ExpandOut } from 'src/components/core/icons';
import { useAppSelector } from 'src/hooks';
import { DepthType, RecentTradeSocketResponseData } from 'src/types';

import { ListHeader, ListItem, ListItemContainer, ListTitle, TradeContainer } from './list';

interface RecentTradeProps {
    isTradeExpand?: boolean;
    setExpandView?: () => void;
}

const RecentTrade: FC<RecentTradeProps> = ({ isTradeExpand, setExpandView }) => {
    const { t } = useTranslation();
    const { isMobile, colors } = useTheme();
    const recentTradeData = useAppSelector((state) => state.socket.trade);
    const symbolInfo = useAppSelector((state) => state.spot.currentSymbol);
    const minPricePrecision: keyof DepthType = symbolInfo?.minPricePrecision;

    return (
        <TradeContainer isTradeExpand={isTradeExpand}>
            <ListHeader isTradeExpand={isTradeExpand}>
                <span>{t('recent_trades')}</span>
                {!isMobile && (
                    <ExpandOut
                        stroke={colors.text.tertiary}
                        style={{ cursor: 'pointer' }}
                        onClick={setExpandView}
                    />
                )}
            </ListHeader>
            <ListTitle>
                <span>{`${t('price')} (${symbolInfo.quoteTokenId})`}</span>
                <span>{`${t('qty')} (${symbolInfo.baseTokenId})`}</span>
                <span>{t('timestamp')}</span>
            </ListTitle>
            <ListItemContainer isTradeExpand={isTradeExpand}>
                {recentTradeData.map((item: RecentTradeSocketResponseData, index) => {
                    return (
                        <ListItem key={index}>
                            <span className={item.m ? 'up' : 'down'}>
                                {currencyFormatter(Number(item.p), DEPTH[minPricePrecision])}
                            </span>
                            <span>
                                {currencyFormatter(
                                    Number(item.q),
                                    DEPTH[symbolInfo?.basePrecision],
                                )}
                            </span>
                            <span>{moment.utc(item.t).local().format('HH:mm:ss')}</span>
                        </ListItem>
                    );
                })}
            </ListItemContainer>
        </TradeContainer>
    );
};

export { RecentTrade };
